/**
 * Accepts what a user can realistically paste: an `open.spotify.com` playlist
 * link (with or without query string / locale segment) or a `spotify:playlist:`
 * URI. Returns the bare playlist ID.
 */
export function parseSpotifyPlaylistId(input: string): string | null {
  const value = input.trim()
  if (value.length === 0) return null

  const uriMatch = /^spotify:playlist:([A-Za-z0-9]+)$/.exec(value)
  if (uriMatch?.[1]) return uriMatch[1]

  const urlMatch =
    /^(?:https?:\/\/)?(?:open|play)\.spotify\.com\/(?:[a-z][a-z0-9-]{0,11}\/)?playlist\/([A-Za-z0-9]+)/.exec(
      value,
    )
  if (urlMatch?.[1]) return urlMatch[1]

  return null
}

export function spotifyPlaylistUrl(playlistId: string): string {
  return `https://open.spotify.com/playlist/${playlistId}`
}

/**
 * A single track, pasted as an `open.spotify.com/track/...` link (with or
 * without a locale segment or query string) or a `spotify:track:` URI.
 */
export function parseSpotifyTrackId(input: string): string | null {
  const value = input.trim()
  if (value.length === 0) return null

  const uriMatch = /^spotify:track:([A-Za-z0-9]+)$/.exec(value)
  if (uriMatch?.[1]) return uriMatch[1]

  const urlMatch =
    /^(?:https?:\/\/)?(?:open|play)\.spotify\.com\/(?:[a-z][a-z0-9-]{0,11}\/)?track\/([A-Za-z0-9]+)/.exec(
      value,
    )
  if (urlMatch?.[1]) return urlMatch[1]

  return null
}
